var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-search",class:[_vm.deviceType]},[_vm._m(0),_c('div',{staticClass:"search-content"},[_c('SearchFilter')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-header"},[_c('div',{staticClass:"search-dot"}),_c('div',{staticClass:"search-title"},[_vm._v("Search by Filter")])])
}]

export { render, staticRenderFns }